













































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import User from "../../../models/security/user.model";
import UserService from "../../../services/user.service";
import { PermissionValue } from "@/enums/PermissionValue";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
@Component({
  components: {
    UserBasicInformationComponent
  }
})
export default class UserTableComponent extends GenericBTable<User> {
  isLoading = false;
  userService = new UserService();
  name = "";

  created() {
    this.permissionValue = PermissionValue.USUARIOS;
    this.tableConfig.controller = "User";
  }

  mounted() {
    this.formatColumns();
  }

  searcherLabel(event: any) {
    if (event.keyCode === 13) {
      this.tableConfig.whereParams = `contains(Name, '${this.name}')`;
      this.tableConfig.reload();
    }
  }

  formatColumns() {
    let fullName = new BTableColumn("fullName", "table.fullname", true);
    fullName.customTemplate = true;
    this.tableConfig.insertColumns(fullName);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }

  confirmDisableUser(user: User) {
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Sí",
      cancelText: "No",
      message: `¿Seguro que desea <b>inhabilitar</b> este usuario <b>(${user.fullName})</b>?`,
      onConfirm: () => this.disableUser(user.id)
    });
  }
  confirmEnableUser(user: User) {
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Sí",
      cancelText: "No",
      message: `¿Seguro que desea <b>habilitar</b> este usuario <b>(${user.fullName})</b>?`,
      onConfirm: () => this.enableUser(user.id)
    });
  }

  disableUser(userId: number) {
    this.userService.disable(userId).then(response => {
      this.tableConfig.reload();
      this.operationSuccess();
    });
  }

  enableUser(userId: number) {
    this.userService.enable(userId).then(response => {
      this.tableConfig.reload();
      this.operationSuccess();
    });
  }

  verOpciones(row: User) {
    this.$router.push(`/user/${row.id}/roles`);
    this.$emit("parent", row);
  }
}
